/**
 * Created by razial on 28.05.2026.
 */

cleverapps.override(cleverapps.Tool, {
    editor: ToolFolder.create(() => {
        if (!Editor.currentEditor) {
            return undefined;
        }

        return {
            bakeBackground: () => {
                const backer = new EditorMap2dBackgroundBaker(Editor.currentEditor);
                backer.bake();
            },
            toggleBackgroundPencil: {
                flag: "backgroundPencil"
            }
        };
    }),
    walkingWorkerPathDebug: ToolEntry.create(
        () => Boolean(cleverapps.meta.getSelectedLocation().locationConfig.usesWorkers && cleverapps.meta.getSelectedLocation().locationConfig.usesWorkers.canWalk),
        { flag: "walkingWorkerPathDebug" }
    )
});
